import React, { useEffect } from "react";
import styled from "styled-components";
import BellIcon from "./images/bell-w.svg";
import SubscribeIcon from "./images/BellIcon-2.svg";
import Bg2003 from "./images/bg-1.png";
import LogoBg from "./images/cescta_combolog-bg.svg";
import { P } from "../CommonStyle";
import Download from "./images/dwnld-w.svg";
import Trend from "./images/ces-trend.svg";
import Innovation from "./images/innovation-trend.svg";
import AR from "./images/ar.svg";
import AI from "./images/ai.svg";
import IOT from "./images/iot.svg";
import CloudData from "./images/cloud.svg";
import Cyber from "./images/cyber.svg";
import Printing from "./images/3d.svg";
import Wireless from "./images/wireless.svg";
import Health from "./images/health.svg";
import Fitness from "./images/fitness.svg";
import Access from "./images/access.svg";
import City from "./images/SmartCity.svg";
import Home from "./images/SmartHome.svg";
import AIR from "./images/air.svg";
import Mobility from "./images/mobility.svg";
import EV from "./images/ev.svg";
import smarthome from "./images/solar_smart-home-outline.svg";
import arhealthycities from "./images/arcticons_healthy-cities.svg";
import carbonvehicleconnected from "./images/carbon_vehicle-connected.svg";
import hugeiconselectricwire from "./images/hugeicons_electric-wire.svg";
import VehicleLight from "./images/VehicleLight.svg";
import arcticonsmobility from "./images/arcticons_mobility.svg";
import Cabin from "./images/cabin.svg";
import SubscribePopup from "./SubscribePopup";
import { useState } from "react";
import DownloadReport from "./DownloadReport";
import { userTrack } from "../Common";
import TopArrow from "./images/scroll-top.svg";
import LimitedTime from "./images/free-report-banner.svg";
import DwFree from "./images/freeTag.svg";
import CESHeartIcon from "./images/CES-Heart-Icon.png";
import TrendEnvi from "./images/TrendEnvi.png";
import TrendsCar from "./images/TrendsCar.png";
import TrendsAIChip from "./images/TrendsAIChip.png";
import TrendsAIMetaImg from "./images/TrendsAIMetaImg.png";
import apronImage from "./images/apronImage.png";
import SolarIcon from "./images/SolarIcon.png";
import CivilIcon from "./images/CivilIcon.png";
import InnovaTanIcon from "./images/InnovaTanIcon.png";
import InnovaHome from "./images/InnovaHome.png";
import InnovaCar from "./images/InnovaCar.png";
import Head from "next/head";
import Image from "next/image";
import CESInnovationCard from "./CESInnovationCard";

const HeaderStick = styled.div`
  background-color: #fff;
  box-shadow: 0px 10px 8.2px 0px rgba(0, 0, 0, 0.25);
  position: fixed;
  width: -webkit-fill-available;
  padding-top: 120px;
  z-index: 1;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 72px;
  margin-left: -20px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 2;

  @-moz-document url-prefix() {
    width: -moz-available;
  }
  @media screen and (max-width: 767px) {
    padding: 8px 15px;
  }
`;
const PillWrapCes = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 767px) {
    gap: 8px;
  }
`;
const PillCont = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0.4px solid #acacac;
  padding: 10px 20px;
  border-radius: 24px;
  cursor: pointer;
  -webkit-text-stroke: 0.1px rgb(69, 69, 69);
  -webkit-text-stroke: 0.5px rgb(21, 67, 109);
  background-color: #bddfff;
  border: 0.4px solid #bddfff;
  @media screen and (max-width: 767px) {
    padding: 10px 7px;
    border-radius: 12px;
    text-align: center;
  }
`;
const PillCont1 = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0.4px solid #acacac;
  padding: 10px 20px;
  border-radius: 24px;
  cursor: pointer;
  -webkit-text-stroke: 0.1px rgb(69, 69, 69);

  &:hover {
    -webkit-text-stroke: 0.5px rgb(21, 67, 109);
    background-color: #bddfff;
    border: 0.4px solid #bddfff;
  }
  @media screen and (max-width: 767px) {
    padding: 10px 7px;
    border-radius: 12px;
    text-align: center;
  }
`;
const SubscribeWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;
const TextSub = styled.p`
    margin: 0;
    text-align: right;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 21px;
    color: #FF7624;
    margin-top: 5px;

    @media screen and (max-width: 767px){
        display: none;
    }
`;
const TextSubG = styled.p`
  margin: 0;
  text-align: right;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 21px;
  color: #454545;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

const SubButton = styled.div`
  border-radius: 12px;
  border: 2px solid #ff7624;
  background: transparent;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background-color: #ff76242b;
  }
  @media screen and (max-width: 767px) {
    border: none;
    padding: 0;
    gap: 5px;
    background-color: transparent;
  }
`;
const ImgBel = styled.div`
  /* width: 74%; */
  margin-top: 7px;
  @media screen and (max-width: 767px) {
    width: 78%;
  }
`;

const TextSubBtn = styled.p`
  margin: 0;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: #ff7624;

  @media screen and (max-width: 767px) {
    font-size: 13px;
    line-height: 14px;
    text-align: left;
  }
`;
const Circle = styled.div`
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 767px) {
  }
`;
const BannerCes = styled.div`
  background-image: url(${Bg2003.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 640px;
  padding-top: 160px;
  position: relative;

  @media screen and (max-width: 767px) {
    height: 755px;
  }
`;
const BgCseContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;

  @media screen and (max-width: 1280px) {
    padding-top: 55px;
  }
  @media screen and (max-width: 767px) {
    padding-top: 125px;
  }
`;

const LogoB = styled.div`
  @media screen and (max-width: 767px) {
    width: 80%;
  }
`;

const BnrTxtThin = styled.p`
  margin: 0 auto;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  margin-top: 20px;
  width: 941px;

  @media screen and (max-width: 767px) {
    width: auto;
    padding: 0 10px;
    font-size: 25px;
  }
`;
const ContentFirst = styled.div`
  margin-top: 70px;
`;
const CntFrstHeader = styled.p`
  margin: 0 auto;
  color: #454545;
  text-align: center;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  width: 1036px;
  margin-bottom: 45px;

  @media screen and (max-width: 1280px) {
    width: 1036px;
  }
  @media screen and (max-width: 767px) {
    width: auto;
    padding: 0 10px;
  }
`;
const CntBox = styled.div`
  border-radius: 43px;
  border: 0.7px solid #f6f6f6;
  background: #fff;
  box-shadow: 0px 0px 119px 0px rgba(0, 0, 0, 0.15);
  padding: 60px 85px;
  margin: 0 63px;

  @media screen and (min-width: 1400px) {
    margin: 0 auto;
    width: 1098px;
  }
  @media screen and (max-width: 767px) {
    padding: 37px 10px;
    margin: 0 10px;
  }
`;
const ContLi = styled.li`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 35px;
  color: #454545;
  margin-bottom: 35px;
`;

const ContLi1 = styled.li`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 31px;
  color: #454545;
  margin-bottom: 25px;
`;
const DwnldBtn = styled.div`
  background-color: #ff7624;
  border-radius: 10px;
  padding: 20px 14px;
  display: flex;
  align-items: center;
  gap: 13px;
  width: 325px;
  margin: 0 auto;
  cursor: pointer;
  position: relative;
  padding-right: 75px;

  &:hover {
    background-color: #cd5900;
  }

  @media screen and (max-width: 767px) {
    width: 204px;
  }
`;
const DwnldImg = styled.div``;

const DwnldBtnTxt = styled.p`
  margin: 0;
  color: #fff;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;

  @media screen and (max-width: 767px) {
    font-size: 13px;
  }
`;
const TrendWrap = styled.div`
  margin-top: 120px;
  margin-left: 62px;
  margin-right: 36px;

  @media screen and (max-width: 1280px) {
    margin-right: 34px;
  }
  @media screen and (min-width: 1400px) {
    margin: 0 auto;
    width: 1276px;
    margin-top: 120px;
  }
  @media screen and (max-width: 767px) {
    margin-right: 0;
    margin-left: 10px;
  }
`;
const HeaderTrend = styled.p`
  margin: 0;
  color: #454545;
  font-family: Roboto;
  font-size: 48px;
  font-style: normal;
  font-weight: 500;
  line-height: 56px;
  letter-spacing: -2px;
  display: flex;
    align-items: center;
    justify-content: center;

  @media screen and (max-width: 767px) {
    text-align: center;
    font-size: 38px;
  }
`;
const TrendFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  margin-top: 40px;

  /* @media screen and (max-width: 767px) { */
    flex-direction: column;
  /* } */
`;
const TrendImg = styled.div`
  width: 448px;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const TrendLi = styled.li`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 37px;
  color: #454545;

  @media screen and (max-width: 1280px) {
    font-size: 15px;
    width: 500px;
  }
  @media screen and (min-width: 1400px) {
    margin-bottom: 7px;
  }
  @media screen and (max-width: 767px) {
    width: auto;
  }
`;
const Span = styled.span`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 33px;
  text-align: justify;
  color: #ff7624;

  @media screen and (max-width: 1280px) {
    font-size: 15px;
  }
`;
const KeyThemeHeader = styled.div`
  margin: 0;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  color: #454545;
  margin-top: 80px;
  margin-bottom: 60px;
  padding-left: 62px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 1400px) {
    padding-left: 0;
    margin: 0 auto;
    width: 1276px;
    margin-top: 80px;
    margin-bottom: 60px;
  }
  @media screen and (max-width: 767px) {
    padding-left: 0px;
    margin-top: 50px;
    text-align: center;
  }
`;
const KeyThemeWrapper = styled.div`
  margin: 0 auto;
  margin: 0 146px;

  @media screen and (min-width: 1400px) {
    margin: 0 auto;
    width: 1206px;
  }
  @media screen and (max-width: 1280px) {
    margin: 0 82px;
  }
  @media screen and (max-width: 767px) {
    margin: 0 20px;
  }
`;
const CradcsWrap = styled.div`
  margin-top: 35px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  row-gap: 22px;
  column-gap: 58px;
  margin-top: 30px;
  margin-bottom: 70px;

  @media screen and (max-width: 767px) {
    justify-content: center;
    column-gap: 20px;
  }
`;
const BlueCard = styled.div`
  border-radius: 12px;
  background: #e3f2ff;
  padding: 27px;
  width: 162px;
  height: 150px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  row-gap: 22px;

  @media screen and (max-width: 767px) {
    width: 103px;
  }
`;
const Icon = styled.div``;

const IconTxt = styled.p`
  margin: 0;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #454545;
  text-align: center;
`;
const ButtonWrapDwn = styled.div`
  margin-top: 120px;
  margin-bottom: 120px;

  @media screen and (max-width: 767px) {
    margin-top: 60px;
    margin-bottom: 130px;
  }
`;
const ScrollTop = styled.div`
  float: right;
  margin-top: -70px;
  margin-right: 25px;
    display: ${({ show }) => (show ? "block" : "none")};
`;
const ScrollArrow = styled.div`
  cursor: pointer;
  position: fixed;
  right: 12px;
  bottom: 20px;
`;
const AdvBanner = styled.div`
  position: absolute;
  left: 0;
  cursor: pointer;

  @media screen and (max-width: 767px) {
    width: 50%;
  }
`;
const DwnldFree = styled.div`
  position: absolute;
  top: -2px;
  right: 6px;
`;

const KeyText = styled.div`
    width: 100%;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    line-height: 44px;
    color: #FF7624;
    margin-bottom: 8px;`;

const TrendTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TrendImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;

  @media screen and (max-width: 1280px) {
    img{
      width: 200px;
    }
  }

  @media screen and (max-width: 767px) {
    img{
      width: 224px;
    }
  }
`;

const InnovationCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
`;

export default function IpCes2003() {
  const [showSub, setShowSub] = useState(false);
  const [showSub1, setShowSub1] = useState(false);

  const handelclick = () => {
    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/ces-2025.html";
    userTrack(`${localStorage.storedEmail}`, "Clicked on CES 2025 Tab", "CES");
  };

  // This method for view Reports
  const suscribe = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "View Reports" `,
      "CES 2024"
    );

    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/ces-2025.html";
  };

  //This is for subscribe
  const suscribePopup = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "Subscribe Now"`,
      "CES 2024"
    );
    setShowSub(true);
  };

  const downlode = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "Download 2024 Report Free" `,
      "CES 2024"
    );
    setShowSub1(true);
  };
  const handleScrollToTop = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      "Clicked on Go on top button",
      "CES 2024"
    );
    // Scroll to the top of the web page
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const HandleSearchCompanies = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      "Clicked on Company Profiles CES 2024 Tab ",
      "CES"
    );
    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/CES-Company-Profiles.html";
  };

  const [showScroll, setShowScroll] = useState(false);

  const handleScroll = () => {
    // Show button after user scrolls 200px down
    if (window.scrollY > 200) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up on unmount
    };
  }, []);

  return (
    <div>
      {/* sticky header */}
      <HeaderStick>
        <div>
          <PillWrapCes>
            <PillCont1 onClick={handelclick}>CES 2025</PillCont1>
            <PillCont>CES 2024</PillCont>

            <PillCont1 onClick={HandleSearchCompanies}>
              Company Profiles - CES 2025
            </PillCont1>
          </PillWrapCes>
        </div>
        {/* <div>
          <SubscribeWrap>
            <div>
              <TextSubG>
                Ideapoke TechLens
                <br /> CES 2024 Reports are here!
              </TextSubG>
            </div>
            <div>
              <SubButton onClick={suscribe}>
                <Circle>
                  <ImgBel>
                    <Image src={BellIcon} alt="BellIcon" />
                  </ImgBel>
                </Circle>
                <TextSubBtn>View Reports</TextSubBtn>
              </SubButton>
            </div>
          </SubscribeWrap>
        </div> */}
        <div>
          {/* <SubscribeWrap>
            <div>
              <TextSubG>Get early access to the</TextSubG>
              <TextSub>Ideapoke CES 2025 Report</TextSub>
            </div>
            <div>
              <SubButton onClick={suscribePopup}>
                <Circle>
                  <ImgBel>
                    <Image
                      src={SubscribeIcon}
                      width=""
                      height="40"
                      alt="BellIcon"
                    ></Image>
                  </ImgBel>
                </Circle>
                <TextSubBtn>Subscribe now</TextSubBtn>
              </SubButton>
            </div>
          </SubscribeWrap> */}
          <SubscribeWrap>
            <div>
              <TextSubG>Ideapoke TechLens<br /> CES 2025 Report is here!</TextSubG>
              {/* <TextSub>Ideapoke CES 2024 Report</TextSub> */}
            </div>
            <div>
              <SubButton onClick={suscribe}>
                <Circle>
                  <ImgBel>
                    <Image width={28} height={28} src={BellIcon} alt="BellIcon" />
                  </ImgBel>
                </Circle>
                <TextSubBtn>View Report</TextSubBtn>
              </SubButton>
            </div>
          </SubscribeWrap>
        </div>
      </HeaderStick>

      {/* Banner */}
      <div>
        <BannerCes>
          {/* <AdvBanner onClick={downlode}>
            <Image src={LimitedTime} alt="LimitedTime" />
          </AdvBanner> */}
          <BgCseContent>
            <LogoB>
              <Image src={LogoBg} alt="LogoBg" />
            </LogoB>
            <P
              text="Ideapoke CES 2024"
              color="#fff"
              fontSize="68px"
              fontWeight="700"
              marginTop="20px"
              mobFontSize="38px"
            ></P>
            <BnrTxtThin>
              Our{" "}
              <span style={{ fontWeight: "800" }}>
                CES 2024 Trends & Innovations Report{" "}
              </span>{" "}
              captures companies & technologies that took the spotlight in 2024
            </BnrTxtThin>
          </BgCseContent>
          <div style={{ marginTop: "30px" }}></div>
          <DwnldBtn onClick={downlode}>
            <DwnldImg>
              <Image src={Download} alt="Download" />
            </DwnldImg>
            <DwnldBtnTxt>Download 2024 Report</DwnldBtnTxt>
            <DwnldFree>
              <Image src={DwFree} alt="DwFree" />
            </DwnldFree>
          </DwnldBtn>
        </BannerCes>

        {/* Download Report */}

        <ContentFirst>
          <CntFrstHeader>
            Explore the revolutionary trends and innovations unveiled at CES
            2024, setting the stage for the upcoming wave of technology.
          </CntFrstHeader>
          <CntBox>
            <ul style={{ paddingLeft: "20px" }}>
              <ContLi>
                The Consumer Electronics Show (CES) is an annual worldwide event
                that serves as a platform for multinational companies and
                startups to exhibit their innovations and unveil their products.
              </ContLi>
              <ContLi>
                Top themes at CES 2024 includes Artificial Intelligence,
                Mobility and Sustainability.
              </ContLi>
              <ContLi>
                CES is one of the most influential global trade shows for tech
                discovery, connections, and business connecting the full
                ecosystem of the tech industry.
              </ContLi>
              <ContLi>
                This report delves into industrial trends, spotlighting key
                company announcements and innovations across various thematic
                areas, with each thematic section presenting comprehensive
                company profiles.
              </ContLi>
            </ul>
            <DwnldBtn onClick={downlode}>
              <DwnldImg>
                <Image src={Download} alt="Download" />
              </DwnldImg>
              <DwnldBtnTxt>Download 2024 Report</DwnldBtnTxt>
              <DwnldFree>
                <Image src={DwFree} alt="DwFree" />
              </DwnldFree>
            </DwnldBtn>
          </CntBox>
        </ContentFirst>

        {/* Trend 2023 */}

        <TrendWrap>
          <HeaderTrend>CES Trends 2024</HeaderTrend>
          <TrendFlex>
            {/* <div>
              <TrendImg>
                <Image width={448} height={539} src={Trend} alt="Trend" />
              </TrendImg>
            </div> */}
            <TrendTextWrapper>
              <P
                text="CES 2024 showcased a range of groundbreaking innovations and technologies. Ideapoke identified several intriguing trends during the event, and here are some of the highlighted trends."
                lineHeight="37px"
                // LgFontSize="19px"
                color="#454545"
                fontSize="20px"
                fontWeight="400"
                width="940px"
                textAlign="center"
                mobwidth="auto"
              ></P>
            </TrendTextWrapper>
            <TrendImageWrapper>
              <Image src={CESHeartIcon} width="" height="" alt="Image"></Image>
              <Image src={TrendEnvi} width="" height="" alt="Image"></Image>
              <Image src={TrendsCar} width="" height="" alt="Image"></Image>
              <Image src={TrendsAIChip} width="" height="" alt="Image"></Image>
              <Image
                src={TrendsAIMetaImg}
                width=""
                height=""
                alt="Image"
              ></Image>
            </TrendImageWrapper>

            <CntBox>
              <KeyText>Key Trends Highlighted at CES 2024</KeyText>
              <ul style={{ paddingLeft: "20px" }}>
                <ContLi1>
                  <b>Women's Health Technology Takes the Spotlight:</b> New
                  health technologies curated for Women's well-being with
                  personalized, holistic solutions through smart wearables and
                  advanced monitoring devices.
                </ContLi1>
                <ContLi1>
                  <b>AI-Powered tech Redefine Mental Health:</b> Showcasing
                  cutting-edge AI-powered mental health tools and products for
                  mental health and wellness device.
                </ContLi1>
                <ContLi1>
                  <b> Advancements in Clean Power Integration:</b> The
                  breakthroughs in renewables and innovative hydrogen solutions
                  are spearheading a shift towards enhanced efficiency across
                  various sectors, including manufacturing, transportation, and
                  electronics.
                </ContLi1>
                <ContLi1>
                  <b> Embracing Sustainable Materials in Consumer Products:</b>{" "}
                  The incorporation of sustainable raw materials from plants and
                  oceans into Consumer products is on the rise. This shift
                  signifies a commitment to eco-friendly practices, emphasizing
                  circular design principles and actively reducing plastic
                  usage.
                </ContLi1>
                <ContLi1>
                  <b>Rise of Healthcare IoT & Sensors:</b> Emphasis on
                  healthcare-related IoT and sensor technologies reflecting a
                  movement towards proactive health monitoring.
                </ContLi1>
                <ContLi1>
                  <b>AI Integration Fuels Versatility & Autonomy: </b>{" "}
                  Integration of AI with robotics, enhancing adaptability and
                  autonomy at larger scale.
                </ContLi1>
                <ContLi1>
                  <b>Increasing Scope of AI Assistants:</b> Beyond commands, AI
                  assistants are evolving into proactive partners, anticipating
                  needs which is expanding their roles.
                </ContLi1>
                <ContLi1>
                  <b>Cloud Technology Empowering Mobility:</b> Artificial
                  Intelligence and Cloud technologies paving way for number of
                  applications across industry, especially mobility.
                </ContLi1>
                <ContLi1>
                  <b>Innovations in Energy Harvesting and Mobility:</b> Smart
                  city innovations in energy and mobility include clear solar
                  glass and electric vehicle charging, paving the way for a
                  greener urban environment.
                </ContLi1>
                <ContLi1>
                  <b>Integration of AI and whole-home monitoring:</b> AI-driven
                  home appliances are gaining attention, offering enhanced
                  functionality and seamless connectivity.
                </ContLi1>
                <ContLi1>
                  <b>The rise of software-defined vehicles:</b> Suppliers and
                  OEMs are taking concrete steps towards the realization of
                  software-defined vehicles.
                </ContLi1>
                <ContLi1>
                  <b>Renewed focus on Hydrogen:</b> New investments in Hydrogen
                  fuel and engines, led by trucking.
                </ContLi1>
              </ul>
            </CntBox>
          </TrendFlex>
        </TrendWrap>

        {/* Innovation 2023 */}

        <TrendWrap>
          <HeaderTrend>Innovations at CES 2024</HeaderTrend>
          <TrendFlex>
            {/* <div>
              <TrendImg>
                <Image
                  width={448}
                  height={302}
                  src={Innovation}
                  alt="Innovation"
                />
              </TrendImg>
            </div> */}
            <TrendTextWrapper>
              <P
                text="Each sector showcases a curated selection of products, categorized into 21 unique themes, offering an in-depth exploration of groundbreaking innovations."
                lineHeight="37px"
                // LgFontSize="19px"
                color="#454545"
                fontSize="20px"
                fontWeight="400"
                width="940px"
                textAlign="center"
                mobwidth="auto"
              ></P>
            </TrendTextWrapper>
            <InnovationCardWrapper>
              <CESInnovationCard
                image={apronImage}
                heading="Accessibility & Health"
                desc="Transformative innovations fostering inclusivity and well-being for all."
              ></CESInnovationCard>
              <CESInnovationCard
                image={SolarIcon}
                heading="Energy & Sustainability"
                desc="Groundbreaking solutions driving clean energy and environmental stewardship."
              ></CESInnovationCard>
              <CESInnovationCard
                image={CivilIcon}
                heading="IoT & Robotics"
                desc="Intelligent systems revolutionizing connectivity and automation."
              ></CESInnovationCard>
              <CESInnovationCard
                image={InnovaTanIcon}
                heading="Next-Gen Technologies"
                desc="Cutting-edge advancements shaping the future of innovation."
              ></CESInnovationCard>
              <CESInnovationCard
                image={InnovaHome}
                heading="Smart Living"
                desc="Integrated technologies redefining comfort and convenience in everyday life."
              ></CESInnovationCard>
              <CESInnovationCard
                image={InnovaCar}
                heading="Vehicle Tech & Advanced Mobility"
                desc="Trailblazing technologies accelerating the future of transportation."
              ></CESInnovationCard>
            </InnovationCardWrapper>
          </TrendFlex>
        </TrendWrap>

        {/* Key Themes */}

        <KeyThemeHeader>
          <div style={{ width: "500px", textAlign: "center" }}>
            Key Product Categories covered in Ideapoke CES 2024 report
          </div>
        </KeyThemeHeader>

        <KeyThemeWrapper>
          <div>
            <P
              text="Accessibility & Health"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image src={AR} alt="Accessibility" />
                </Icon>
                <IconTxt>Accessibility</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={AI} alt="Digital Health" />
                </Icon>
                <IconTxt>Digital Health</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={IOT} alt="Fitness & Wearables" />
                </Icon>
                <IconTxt>Fitness & Wearables</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={CloudData} alt="Wellness Technologies" />
                </Icon>
                <IconTxt>Wellness Technologies</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
          <div>
            <P
              text="Energy & Sustainability"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image src={AIR} alt="Energy/Power" />
                </Icon>
                <IconTxt>Energy/Power</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={Mobility} alt="Sustainability" />
                </Icon>
                <IconTxt>Sustainability</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={EV} alt="Sourcing and Manufacturing" />
                </Icon>
                <IconTxt>Sourcing and Manufacturing</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
          <div>
            <P
              text="IoT & Robotics"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image src={Health} alt="Robotics" />
                </Icon>
                <IconTxt>Robotics</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={IOT} alt="IoT/Sensors" />
                </Icon>
                <IconTxt>IoT/Sensors</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
          <div>
            <P
              text="Next-Gen Technologies"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image src={Home} alt="Artificial Intelligence" />
                </Icon>
                <IconTxt>Artificial Intelligence</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={City} alt="Cybersecurity" />
                </Icon>
                <IconTxt>Cybersecurity</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={Access} alt="AR/VR/XR" />
                </Icon>
                <IconTxt>AR/VR/XR</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={Fitness} alt="5G Technologies" />
                </Icon>
                <IconTxt>5G Technologies</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={Wireless} alt="Cloud Computing/Data" />
                </Icon>
                <IconTxt>Cloud Computing/Data</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
          <div>
            <P
              text="Smart Living"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image src={smarthome} alt="Smart Home and Appliances" />
                </Icon>
                <IconTxt>Smart Home and Appliances </IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={arhealthycities} alt="Smart Cities" />
                </Icon>
                <IconTxt>Smart Cities</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
          <div>
            <P
              text="Vehicle Tech & Advanced Mobility"
              MobtextAlign="center"
              color="#352960"
              fontSize="24px"
              fontWeight="500"
              marginTop="20px"
            ></P>
            <CradcsWrap>
              <BlueCard>
                <Icon>
                  <Image
                    src={carbonvehicleconnected}
                    alt="Connected and Autonomous Mobility "
                  />
                </Icon>
                <IconTxt>Connected and Autonomous Mobility </IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image
                    src={hugeiconselectricwire}
                    alt="Electric and Alternative Fuels"
                  />
                </Icon>
                <IconTxt>Electric and Alternative Fuels</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image
                    src={VehicleLight}
                    alt="In-Car Technology and Infotainment"
                  />
                </Icon>
                <IconTxt>In-Car Technology and Infotainment</IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={arcticonsmobility} alt="Air Mobility " />
                </Icon>
                <IconTxt>Air Mobility </IconTxt>
              </BlueCard>
              <BlueCard>
                <Icon>
                  <Image src={Cabin} alt="Software Defined Vehicle" />
                </Icon>
                <IconTxt>Software Defined Vehicle</IconTxt>
              </BlueCard>
            </CradcsWrap>
          </div>
        </KeyThemeWrapper>

        <ButtonWrapDwn>
          <DwnldBtn onClick={downlode}>
            <DwnldImg>
              <Image src={Download} alt="AI" />
            </DwnldImg>
            <DwnldBtnTxt>Download 2024 Report</DwnldBtnTxt>
            <DwnldFree>
              <Image src={DwFree} alt="DwFree" />
            </DwnldFree>
          </DwnldBtn>
        </ButtonWrapDwn>
      </div>

      {/* Scroll Top */}
      <ScrollTop show={showScroll}>
        <ScrollArrow onClick={handleScrollToTop}>
          <Image src={TopArrow} alt="TopArrow" />
        </ScrollArrow>
      </ScrollTop>

      {showSub && <SubscribePopup setShowSub={setShowSub}></SubscribePopup>}
      {showSub1 && <DownloadReport setShowSub={setShowSub1}></DownloadReport>}
    </div>
  );
}
